<template>
  <div>
    <h3 class="title is-3">Intros</h3>
    <button class="button is-primary" @click="openIntroTextCreator">Create a Intro</button>

    <b-table
        :data="introTexts"
        :default-sort="['createdDate', 'desc']"
        :hoverable="true"
        :loading="isLoading"
        :striped="true">
      <template slot-scope="props">
        <b-table-column class="centered-table-content" field="createdDate" label="Creation Date">
          {{ props.row.createdDate }}
        </b-table-column>
        <b-table-column class="centered-table-content" field="name" label="Name" sortable>
          {{ props.row.name }}
        </b-table-column>

        <b-table-column class="centered-table-content" field="nbCards" label="Nb cards" numeric sortable>
          {{ getIntroTextCount(props.row.cards) }}
        </b-table-column>

        <b-table-column class="centered-table-content" field="cardsTitles" label="Cards Titles">
          <ul>
            <li v-for="card in props.row.cards" :key="card.title">
              {{ card.title }}
            </li>
          </ul>
        </b-table-column>

        <b-table-column class="centered-table-content" label="Actions">
          <button class="button is-primary is-outlined" style="margin-left: 5px;"
                  @click="openEditIntroText(props.row.introTextId)"
          >Edit
          </button>
          <button class="button is-danger is-outlined" style="margin-left: 5px;"
                  @click="openIntroTextDeleteDialog(props.row.introTextId)">Delete
          </button>
        </b-table-column>
      </template>
    </b-table>

  </div>
</template>

<script>
import introTextService from '../services/introTextsService'
import {DialogProgrammatic as Dialog} from 'buefy'
import displayHelper from '../helpers/display-helper'

export default {
  name: 'IntroTexts',
  data() {
    return {
      isLoading: false,
      introTexts: [],
    }
  },
  created() {
    this.isLoading = true
    this.loadIntroTextsList()
  },
  methods: {
    getIntroTextCount(cards) {
      return cards ? cards.length : 0
    },
    loadIntroTextsList() {
      var parent = this
      introTextService.getIntroTexts()
          .then(introTexts => {
            this.introTexts = introTexts
            this.isLoading = false
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Oops.. An error occurred: ' + err.message)
          })
    },
    openIntroTextDeleteDialog(introTextId) {
      Dialog.confirm({
        message: 'Are you sure you want to delete this Intro?',
        onConfirm: () => this.deleteIntroText(introTextId)
      })
    },
    deleteIntroText(introTextId) {
      var parent = this
      this.isLoading = true
      introTextService.deleteIntroText(introTextId)
          .then(() => {
            displayHelper.displaySuccess(parent, 'IntroText successfully deleted')
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Error while deleting the intro: ' + err.message)
          })
          .finally(() => {
            this.loadIntroTextsList()
          })
    },
    openIntroTextCreator() {
      this.$router.push(`introTexts/create`)
    },
    openEditIntroText(introTextId) {
      this.$router.push({name: 'EditIntroText', params: {id: introTextId}})
    },
    createIntroText(name) {
      var parent = this
      this.isLoading = true
      introTextService.createIntroText(name)
          .then(() => {
            displayHelper.displaySuccess(parent, 'Intro successfully added')
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Error while adding the intro: ' + err.message)
          })
          .finally(() => {
            this.loadIntroTextsList()
          })
    }
  }
}
</script>

<style scoped>
.btn-margin {
  margin-left: 10px;
  margin-right: 10px;
}
</style>
